import React from "react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

/* ---------------- Apply Special dialog (invoice-wide) ---------------- */
export default function ApplySpecialDialog({ open, onOpenChange, specials, current, onApply, onRemove }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="apply-special-dialog">
        <DialogHeader>
          <DialogTitle>Apply Special</DialogTitle>
          <DialogDescription>Applied to the whole invoice&apos;s base price, before surcharge + tax. Only one invoice special at a time.</DialogDescription>
        </DialogHeader>
        {current && (
          <div className="rounded-md border border-primary/40 bg-primary/5 p-3 flex items-center justify-between mb-2">
            <div className="text-sm">Currently applied: <span className="font-medium">{current.name}</span></div>
            <Button size="sm" variant="ghost" onClick={onRemove} data-testid="clear-invoice-special">Remove</Button>
          </div>
        )}
        <div className="max-h-72 overflow-auto rounded-md border border-border divide-y divide-border">
          {specials.length === 0 ? (
            <p className="p-4 text-sm text-muted-foreground text-center">No active specials. Create one under <span className="font-medium">Marketing → Specials</span>.</p>
          ) : specials.map((s) => (
            <button
              key={s.id}
              className="w-full text-left p-3 hover:bg-muted/40 flex items-center justify-between gap-2"
              onClick={() => onApply(s.id)}
              data-testid={`invoice-special-${s.id}`}
            >
              <div>
                <div className="text-sm font-medium">{s.name}</div>
                {s.promo_code && <div className="text-[11px] text-muted-foreground">Code: {s.promo_code}</div>}
              </div>
              <Badge variant="outline" className="rounded-full text-[11px]">
                {s.discount_type === "percent" ? `${s.discount_value}% off` : `-${s.discount_value}`}
              </Badge>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
